import React, { useContext, useEffect } from "react";

import Breadcrumb from "../components/Breadcrumb";

import SideMenu from "../components/SideMenu";
import Navbar from "../components/Navbar";
import DeviceChart from "../components/DeviceChart";
import TotalVisitors from "../components/TotalVisitors";
import CountryList from "../components/CountryList";
import CityList from "../components/CityList";

import { AuthContext } from "../context/AuthContext";
import VisitorChart from "../components/VisitorChart";

function Analytic() {
  const { userData } = useContext(AuthContext);
  useEffect(() => {
    document.title = "Analytics";
    return () => {
      document.title = "Flipcard";
    };
  }, []);

  return (
    <>
      {userData && (
        <>
          <Navbar />
          <div className="content">
            <div className="side-left">
              <SideMenu />
            </div>
            <div className="side-right">
              <Breadcrumb title="Analytics" />
              <TotalVisitors />
              <DeviceChart />
              <VisitorChart />
              <CountryList />
              <CityList />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Analytic;
